import { useEffect } from "react";

import { useInView } from "react-intersection-observer";

export default function Waypoint({
  stocks,
  advanceSearchCount,
  page,
  setPage,
}) {
  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && stocks?.length > 10 && advanceSearchCount > stocks?.length) {
      setPage(page + 1);
    }
  }, [inView]);

  return <div ref={ref} style={{ height: 1 }} />;
}
